import { languageHelper } from "../../../config/helperFunctions";
import React, { useState } from "react";
import CardTable from "../../../components/AdminTable/CardTable";
import Dropdown from "../../../components/AdminDropdown/Dropdown";

function SuppliersPayment() {
  const [columns] = useState([
    {
      header: languageHelper("SN"),
      accessorKey: "SN",

    },
    {
      header: languageHelper("Date"),
      accessorKey: "Date",
    },
    {
      header: languageHelper("Supplier"),
      accessorKey: "Supplier",
    },
    {
      header: languageHelper("Amount"),
      accessorKey: "Amount",
    },
    {
      header: languageHelper("Note"),
      accessorKey: "Note",
    },
    {
      header: languageHelper("DOB"),
      accessorKey: "DOB",
    },
    {
      header: languageHelper("Added By"),
      accessorKey: "AddedBy",
    },
    {
      header: languageHelper("Actions"),
      accessorKey: "total",
      cell: (row) => <Dropdown />,
    },

  ]);
  const [data] = useState([


  ]);
  const [buttonData] = useState([
    {
      buttonText: languageHelper("Add Supplier Due Payment"),
      path: "addSupplierPaymentForm"
    },

  ]);

  return (
    <main>
      <CardTable
        data={data}
        columns={columns}
        heading={languageHelper("Supplier Due Payments")}
        buttonData={buttonData}


      />
    </main>
  );
}

export default SuppliersPayment;
